import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password Reset Email Sent. If an account exists for this email address, a password reset link has been sent. Please check your inbox and spam folder.');
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else {
        // As per security requirement: Do not expose whether an email exists.
        // Even if Firebase throws auth/user-not-found, we show the success message.
        // Note: Firebase's new email enumeration protection inherently prevents auth/user-not-found.
        // We catch network errors or other specific failures here.
        setError('Unable to send reset email. Please try again.');
      }
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-bg-primary px-4">
      <div className="card w-full max-w-md p-8 relative overflow-hidden">
        {/* Subtle background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-accent-primary/10 blur-3xl rounded-full"></div>
        
        <div className="relative z-10">
          <div className="text-center mb-8 flex flex-col items-center">
            <h1 className="text-3xl font-display font-bold text-text-primary tracking-wide">DVPL ERP</h1>
            <p className="text-text-secondary mt-1 text-sm">Enterprise Construction Management Platform</p>
            <p className="text-text-muted mt-2 text-xs uppercase tracking-wider">Powered By <span className="text-text-primary font-medium">Dee Vee Projects Limited</span></p>
          </div>

          <h2 className="text-xl font-bold text-text-primary mb-2">Reset Your Password</h2>
          <p className="text-text-secondary text-sm mb-6">
            Enter your registered email address and we will send you a password reset link.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-status-danger/10 border border-status-danger/30 rounded text-status-danger text-sm">
              {error}
            </div>
          )}

          {message && (
            <div className="mb-4 p-4 bg-status-success/10 border border-status-success/30 rounded text-status-success text-sm font-medium">
              {message}
            </div>
          )}

          {!message && (
            <form onSubmit={handleResetPassword} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Email Address</label>
                <input 
                  type="email" 
                  required
                  className="input-field"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary w-full py-3 mt-4 text-base"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" className="text-sm font-medium text-accent-primary hover:text-text-primary transition-colors">
              Back To Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
